import React from 'react';
// import Languages from '../../components/languages/indes';
import PolicyTitle from '../../components/policyTitle';
import PolicyContent from '../../components/policyContent';


const Ours = () => {
    return (
        <>
            {/* <div>
                <FrameImage image={Volunteers} section="ours" />
            </div> */}
            <div>
                <PolicyTitle />
            </div>
            <div>
                <PolicyContent />
            </div>
        </>



    );
}

export default Ours;